/* tslint:disable */
/* eslint-disable */
/**
 * Melco Efs APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    EfsMelcoEfsModelsQueueProcessor,
    EfsMelcoEfsModelsQueueProcessorFromJSON,
    EfsMelcoEfsModelsQueueProcessorFromJSONTyped,
    EfsMelcoEfsModelsQueueProcessorToJSON,
    EfsMelcoModelsCustomWarning,
    EfsMelcoModelsCustomWarningFromJSON,
    EfsMelcoModelsCustomWarningFromJSONTyped,
    EfsMelcoModelsCustomWarningToJSON,
} from './';

/**
 * 
 * @export
 * @interface EfsMelcoModelsGenericList1MelcoEfsModelsQueueProcessor
 */
export interface EfsMelcoModelsGenericList1MelcoEfsModelsQueueProcessor {
    /**
     * 
     * @type {Array<EfsMelcoEfsModelsQueueProcessor>}
     * @memberof EfsMelcoModelsGenericList1MelcoEfsModelsQueueProcessor
     */
    list: Array<EfsMelcoEfsModelsQueueProcessor>;
    /**
     * 
     * @type {Array<EfsMelcoModelsCustomWarning>}
     * @memberof EfsMelcoModelsGenericList1MelcoEfsModelsQueueProcessor
     */
    warning_list?: Array<EfsMelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof EfsMelcoModelsGenericList1MelcoEfsModelsQueueProcessor
     */
    total: number;
}

export function EfsMelcoModelsGenericList1MelcoEfsModelsQueueProcessorFromJSON(json: any): EfsMelcoModelsGenericList1MelcoEfsModelsQueueProcessor {
    return EfsMelcoModelsGenericList1MelcoEfsModelsQueueProcessorFromJSONTyped(json, false);
}

export function EfsMelcoModelsGenericList1MelcoEfsModelsQueueProcessorFromJSONTyped(json: any, ignoreDiscriminator: boolean): EfsMelcoModelsGenericList1MelcoEfsModelsQueueProcessor {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(EfsMelcoEfsModelsQueueProcessorFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(EfsMelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function EfsMelcoModelsGenericList1MelcoEfsModelsQueueProcessorToJSON(value?: EfsMelcoModelsGenericList1MelcoEfsModelsQueueProcessor | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(EfsMelcoEfsModelsQueueProcessorToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(EfsMelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


